export const ADHIKARI_CONSTANT = {
  ADHIKARI_LIST: "/adhikari/list",
  ADHIKARI_DATA: "/adhikari",
  DEPARTMENT: "/department",
  CAST: "/cast",
  SUBCAST: "/common/subcast",
  TOTAL_COUNT: "/adhikari/total/count",
  ASSEMBLIES_LIST: "/common/assemblies",
  GAON_LIST: "/common/gaon",
  GATNO_LIST: "/common/gat",
  GAN_NUMBER_LIST: "/common/gan",
  ADHIKARI_ASSEMBLY:
    "?join=assembly&join=cityType&join=gat_number&join=gan_number&join=gaon&join=role",
};
export const ADHIKARI_EXCEL_DATA = {
  COLUMN_DEFINATION: [
    {
      isObj: true,
      displayName: "Assembly",
      obj: "assembly",
      valueKey: ["name"],
    },
    {
      isObj: true,
      displayName: "Gat",
      obj: "gat_number",
      valueKey: ["name"],
    },
    {
      isObj: true,
      displayName: "Gan",
      obj: "gan_number",
      valueKey: ["name"],
    },
    {
      isObj: true,
      displayName: "Gaon",
      obj: "gaon",
      valueKey: ["name"],
    },
    {
      isObj: true,
      displayName: "Prabhag",
      obj: "prabhag",
      valueKey: ["name"],
    },
    {
      isObj: true,
      displayName: "Prabhag Area",
      obj: "prabhagArea",
      valueKey: ["name"],
    },
    {
      isObj: false,
      displayName: "Note",
      valueKey: ["description"],
    },
  ],
};
